import { utils as reducerUtils } from 'redux-rest-reducer';

import { STUDENT_BADGE_STATUS } from '@cuemath/leap';
import { ACTIONS } from '@~/actions/rewards-home';
import { getCurrentSelectedProgram } from '@~/utils/program';

import RestReducer from './reducer';

const SENT = 'SENT';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  const { id: payloadId, query } = payload || {};

  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payloadId, query);
    default:
      return state;
  }
});

export function getRewardsHomeQuery(studentClassroomId, studentCurriculumHome) {
  const { data: curriculumData } = studentCurriculumHome || {};
  const { user_programs: userPrograms } = curriculumData || {};
  const currentProgram = getCurrentSelectedProgram(userPrograms);
  const {
    badges_enabled: isProgramBadgesEnabled,
    id: programId,
    rewards_enabled: isProgramRewardsEnabled,
  } = currentProgram || {};
  const badges = !!isProgramBadgesEnabled;
  const stickers = !!studentClassroomId;

  const rewardHomeQuery = {
    program_id: programId,
    rewards: isProgramRewardsEnabled,
    badges,
    ...(badges && { badges_state: STUDENT_BADGE_STATUS.ASSIGNED }),
    stickers,
    ...(stickers && {
      student_classroom_id: studentClassroomId,
      state: SENT,
    }),
  };

  return rewardHomeQuery;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getWinsTabRewardsHomeQuery(currentProgram, isMilestonePlanEnabled) {
  const query = {
    badges: true,
    rewards: true,
    stickers: true,
  };

  return query;
}

export const getWinsTabRewardQuery = enrolledPrograms => {
  if (!enrolledPrograms) return null;

  const currentProgram = getCurrentSelectedProgram(enrolledPrograms);
  const winsQuery = getWinsTabRewardsHomeQuery(currentProgram);

  return winsQuery;
};
